var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    staticStyle: {
      "margin-bottom": "20px",
      width: "100%"
    },
    attrs: {
      layout: "inline"
    }
  }, [_c("a-form-item", [_c("div", {
    staticClass: "btns",
    class: _vm.current == 1 ? "left" : "",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticClass: "btn",
    class: _vm.current == 1 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 1;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("全部")))]), _c("div", {
    staticClass: "btn",
    class: _vm.current == 0 ? "hit" : "",
    on: {
      click: function ($event) {
        _vm.current = 0;
      }
    }
  }, [_c("a-badge", {
    attrs: {
      count: _vm.num
    }
  }, [_c("div", {
    staticStyle: {
      height: "40px",
      display: "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("待我操作")) + " ")])])], 1)])])], 1), _vm.current == 0 ? _c("examine-list", {
    on: {
      ok: _vm.getNumFun
    }
  }) : _vm._e(), _vm.current == 1 ? _c("all-list", {
    on: {
      ok: _vm.getNumFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };